var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.label
    ? _c(
        "a",
        {
          staticClass: "inline-block btn btn-default margin-right",
          class: [
            {
              "pointer-events-none cursor-auto":
                !_vm.filterable && !_vm.removable,
              "cursor-auto no-hover": _vm.removable,
            },
            `btn-${_vm.size}`,
          ],
          attrs: {
            title: _vm.filterable ? `Filter by label '${_vm.label}'` : "",
            href: _vm.getUrl(_vm.label),
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.labelCharacterLimit > _vm.label.length
                  ? _vm.label
                  : _vm.label.substring(0, 12) + ".."
              ) +
              "\n    "
          ),
          _vm.removable
            ? _c(
                "span",
                {
                  staticClass: "cursor-pointer",
                  attrs: { title: `Remove label '${_vm.label}'` },
                  on: { click: _vm.removeLabel },
                },
                [_c("strong", [_vm._v("×")])]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }